export default "__VITE_ASSET__CEpJx2lU__"